import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import { type ErrorComponentProps, Link } from "@tanstack/react-router";

export function DefaultErrorComponent({ error }: { error: ErrorComponentProps }) {
  const erro =
    error.error && typeof error.error === "object" && "mensagem" in error.error
      ? (error.error.mensagem as string)
      : String(error.error);

  return (
    <Box sx={{ pt: 5, px: 2.5, mb: "auto", color: "#000" }}>
      <Box sx={{ display: "flex", alignItems: "start", mb: 1.5 }}>
        <Typography sx={{ fontWeight: "bold", mb: 1.5, fontSize: "36px" }}>Oops!</Typography>
      </Box>

      <Box sx={{ color: "#6b7280", fontSize: "18px" }}>
        We encountered an unexpected issue with your browser and couldn't load the page.
      </Box>

      <Box
        sx={{
          margin: "50px 0px",
          border: "2px solid #eaeaea",
          backgroundColor: "rgba(250, 250, 250, 0.7)",
          width: "100%",
          padding: 40,
          borderRadius: 5,
        }}
      >
        <Typography sx={{ fontWeight: "blod", fontSize: "18px" }}>Issue:</Typography>
        <Typography sx={{ color: "#6b7280", fontSize: "16px" }}>{erro}</Typography>
      </Box>

      <Link to="/">
        <Button>Return to the homepage</Button>
      </Link>
    </Box>
  );
}
